export default __webpack_public_path__ + "static/media/AppleApp.ac488d16.svg";